import React from "react";
import "../css/RegistrationStatus.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart  } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useSearchParams  } from "react-router-dom";
import RegistrationButton from "./RegistrationButton";

const RegistrationStatus = ({ registrationStatus, guid }) => {
  const { status, startDate, endDate } = registrationStatus;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const buildUrl = (path, searchParams) => {
    const search = searchParams?.toString();
    return search ? `${path}?${search}` : path;
  };

  const handleRegisterClick = () => {
    navigate(buildUrl(`/register/${guid}`, searchParams));
  };

  const formatDate = (date) =>
    date
      ? new Date(date).toLocaleDateString("pl-PL", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
      : "-";

  const formatTime = (date) =>
    date
      ? new Date(date).toLocaleTimeString("pl-PL", {
          hour: "2-digit",
          minute: "2-digit",
        })
      : "-";

      const renderMessage = () => {
        const registrationMessage = registrationStatus.registrationMessage; 
      
        switch (status) {
          case 0: 
            return (
              <p className="registration-upcoming">
                {registrationMessage ? (
                  registrationMessage
                ) : (
                  <>
                    Zapisy na wycieczkę rozpoczną się{" "}
                    <strong>{formatDate(startDate)}</strong> o godzinie{" "}
                    <strong>{formatTime(startDate)}</strong>.
                  </>
                )}
              </p>
            );
          case 1: 
            return (
              <>
                <p className="registration-started">
                  {registrationMessage ? (
                    registrationMessage
                  ) : (
                    <>
                      Zapisy potrwają do <strong>{formatDate(endDate)}</strong>,{" "}
                      <strong>{formatTime(endDate)}</strong>.
                    </>
                  )}
                </p>
                <button className="registration-standard-button" onClick={handleRegisterClick}>
                  Zapisz się teraz
                </button>
                <RegistrationButton handleRegisterClick={handleRegisterClick} />
              </>
            );
          case 2: 
            return (
              <p className="registration-finished">
                Zapisy na tę wycieczkę zostały zakończone.
              </p>
            );
            case 3:
            return (
              <>
                  {registrationMessage ? (
                     <p className="registration-finished">
                     {registrationMessage}
                   </p>
                  ) : (
                    <>
                     <p className="registration-waitlist">
                      Obecnie trwają zapisy na listę rezerwową i potrwają do{" "}
                      <strong>{formatDate(endDate)}</strong>, <strong>{formatTime(endDate)}</strong>.
                      </p>
                      <button className="registration-standard-button" onClick={handleRegisterClick}>
                        Zapisz się na listę rezerwową
                      </button>
                      <RegistrationButton handleRegisterClick={handleRegisterClick}/>
                    </>
                  )}

               
              </>
            );
          default:
            return <p>Status rejestracji nie jest dostępny.</p>;
        }
      };
      

  return <div className="registration-status">{renderMessage()}</div>;
};

export default RegistrationStatus;
